export const launchScreen = {
	queryTitle: '',
	queryPlaceholder: '',
	previewHeader: '',
	goBack: 'Go back to conversation',
	lastMessage: '',
	lastMessageDate: '3:30 PM',
	timeout: 'Session timed out for your ongoing conversation',
};
